import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const SelectClientContainer = styled.div`
  margin: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;


  & > div {
    display: flex;
    flex-direction: column;
    width: 356px;
    gap: 10px;
    flex-direction: column;
    align-items: center;
    justify-content: start;
  }

  & > div > h3 {
    font-weight: 600;
    font-size: 14px;
    line-height: 180%;
    margin: 0;
    color: ${colors.text['main-900']};
  }

  & > div > p {
    font-weight: 400;
    font-size: 12px;
    line-height: 180%;
    color: ${colors.text['sub-500']};
    text-align: center;
  }
`;
